import { CartIcon } from "@theme/assets";
import { navigate } from "gatsby";
import { useSetAtom } from "jotai";

import { MsButton, Text, flyoutCartOpen } from "@theme/components";

import type { NavigationDataProps } from "@theme/types";
import type { FC } from "react";

interface NavCartLinkProps {
  /** Amount of items in the cart */
  navData: NavigationDataProps;
}

export const NavCartLink: FC<NavCartLinkProps> = ({ navData }) => {
  const setIsFlyoutCartOpen = useSetAtom(flyoutCartOpen);
  const { cart, isBlog } = navData;

  return (
    <MsButton
      onClick={() => (isBlog ? navigate(cart.to) : setIsFlyoutCartOpen(true))}
      aria-label="Go to cart"
      variant="iconDark"
      sx={{
        svg: {
          color: cart.itemsInCart && cart.itemsInCart > 0 ? "goldPrimary" : "grey400",
        },
        "span.cart-link-text": {
          position: "absolute",
          bottom: "13px",
          left: "50%",
          transform: "translateX(-50%)",
          color: "white",
          fontSize: "9px",
          lineHeight: "lh100",
        },
      }}
    >
      <CartIcon
        sx={{
          color: cart.itemsInCart && cart.itemsInCart > 0 ? "goldPrimary" : "grey400",
          width: "iconSizeBase",
          height: "auto",
        }}
      />
      <Text className="cart-link-text">{cart.itemsInCart}</Text>
    </MsButton>
  );
};
